import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import './index.css';
import App from './App';
import store from './store';

const theme = createTheme({
    palette: {
        primary: {
            main: '#005cAA'
        },
        secondary: {
            main: '#2D68FF',
        },
    }
});

render(
    <MuiThemeProvider theme={theme}>
        <Provider store={store}>
            <App />
        </Provider>
    </MuiThemeProvider>,
    document.getElementById('root')
);
